import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormError from "../../../shared/components/FormError";
import { loadFullPartTimeUpdateDataRequest } from "../redux/Actions";
import FullPartTimeForm from "./FullPartTimeForm";

const FullPartTimeEdit = ({ handleClose, fullPartTime }) => {
  const dispatch = useDispatch();
  let [shouldCloseModal, setShouldCloseModal] = useState(false);
  let [errorMessage, setErrorMessage] = useState(false);

  let { loading, error } = useSelector((state) => state.fullPartTime);

  // After submition, the post request is done loading, and there's no errors
  useEffect(() => {
    if (shouldCloseModal && !loading) {
      if (!error) {
        handleClose(true);
      } else {
        setErrorMessage(error.msg);
      }
      setShouldCloseModal(false);
    }
  }, [loading, error, shouldCloseModal]);

  function submit(values) {
    dispatch(loadFullPartTimeUpdateDataRequest(values));
    setShouldCloseModal(true);
  }
  function cancel() {
    handleClose(false);
  }
  return (
    <>
      <FormError>
        {errorMessage}
      </FormError>
      <FullPartTimeForm
        submit={submit}
        cancel={cancel}
        fullPartTime={fullPartTime}
      />
      ;
    </>
  );
};

export default FullPartTimeEdit;
